import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import _ from 'lodash';

import { useRouter } from 'next/router';

import RoomTypeCard from '../room-types/room-type-card.component';

import { sortRoomTypes } from '../../../utils/sort';

import useResponsive from '../../../utils/responsive';

import FeaturedSpacesMobileCarousel from './featured-spaces-mobile-carousel.component';

import { LinkUnderlineAnimation } from '../shared';

const FeaturedSpacesBuilding = (props) => {    

    const { isMobile } = useResponsive(); 

    const { selectedBuilding, id, visibleRooms, text, selectedCity, roomTypes, allPortfolios } = props;

    const [sortedRoomTypes, setSortedRoomTypes] = useState([]);    
    
    const name = _.get(selectedBuilding, 'name');
    const cityName = _.get(selectedCity, 'name');
    const buildingId = _.get(selectedBuilding, 'id');
    const router = useRouter();
    const roomTypeId = _.get(router, 'query.roomTypeId');

    useEffect(() => {
        const sorted = sortRoomTypes(roomTypes, 'numberAvailable');
        if (roomTypeId) {
            _.remove(sorted, (roomType) => roomType.id === roomTypeId);
        }
        setSortedRoomTypes(sorted);
    }, [roomTypes, roomTypeId]);

    if (!roomTypes || _.size(roomTypes) <= 1) {
        return null;
    }

    const renderRoomCards = () => {        
        if (!roomTypes) {
            return null;
        }

        return _.map(sortedRoomTypes, (roomType, index) => {
            _.set(roomType, 'id', roomType.ids[0].roomTypeId);
            if (
                _.get(roomType, 'numberAvailableForFemales') &&
                _.get(roomType, 'numberAvailableForMales')
            ) {
                if (
                    _.get(roomType, 'numberAvailableForFemales') <
                    _.get(roomType, 'numberAvailableForMales')
                ) {
                    _.set(roomType, 'gender', 'female');
                    _.set(
                        roomType,
                        'numberAvailable',
                        _.get(roomType, 'numberAvailableForFemales'),
                    );
                } else {
                    _.set(roomType, 'gender', 'male');
                    _.set(roomType, 'numberAvailable', _.get(roomType, 'numberAvailableForMales'));
                }
            }

            if (index < visibleRooms) {
                return (
                    <div className='main-grid-item main-grid-xl-4 main-grid-lg-4 main-grid-md-4 main-grid-sm-6 main-grid-xs-12' key={roomType.id}>
                        <RoomTypeCard roomType={roomType} allPortfolios={allPortfolios} />
                    </div>
                );
            }
            return null;
        });
    };

    if (isMobile) {
        return (
            <FeaturedSpacesMobileCarousel
                data={sortedRoomTypes}
                renderRoomCards={renderRoomCards}
                selectedBuilding={name}
                selectedBuildingId={buildingId}
                title={text}
                href={`/bookings/?city=${cityName}&building=${buildingId}`}
            />
        );
    }

    return (

        <div className='container-root container-root-maxWidthLg'>

            <div className='featured-spaces-building-content-container' id={id}>

                <div className='featured-spaces-building-row'>

                    <div>

                        <h4>
                            {text} in {name}
                        </h4>

                        <p className='featured-spaces-building-paragraph'>Your space is waiting for you</p>

                    </div>

                    <LinkUnderlineAnimation
                        id="browse-more-rooms"
                        href={`/bookings/?city=${cityName}&building=${buildingId}`}
                    >
                        Browse All
                    </LinkUnderlineAnimation>

                </div>

                <div className='main-grid-container main-grid-spacing-xs-4 featured-spaces-building-grid' justify="flex-start">
                    {renderRoomCards()}
                </div>

            </div>

        </div>

    );
};

export default FeaturedSpacesBuilding;

FeaturedSpacesBuilding.propTypes = {
    roomTypes: PropTypes.array,
    selectedBuilding: PropTypes.object,
    id: PropTypes.string,
    visibleRooms: PropTypes.number,
    selectedCity: PropTypes.object,
    text: PropTypes.string,
    allPortfolios: PropTypes.arrayOf(PropTypes.object),
};

